import { render, staticRenderFns } from "./RelatorioPage.vue?vue&type=template&id=7edab46c&"
import script from "./RelatorioPage.vue?vue&type=script&lang=ts&"
export * from "./RelatorioPage.vue?vue&type=script&lang=ts&"
import style0 from "./RelatorioPage.vue?vue&type=style&index=0&id=7edab46c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VAppBar,VBtn,VCard,VCol,VIcon,VRow,VSpacer,VToolbarItems,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edab46c')) {
      api.createRecord('7edab46c', component.options)
    } else {
      api.reload('7edab46c', component.options)
    }
    module.hot.accept("./RelatorioPage.vue?vue&type=template&id=7edab46c&", function () {
      api.rerender('7edab46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/RelatorioPage.vue"
export default component.exports